import { useState, useCallback, useEffect } from "react";
import { GET_CLIENT_CONTACT, GET_USERS_RS } from "../api/apiAdmin";
import { GET_ASSISTANTS_BY_CLIENT } from "../api/apiUsuariosExt";

const useFetchMeetingData = (empresa) => {
  const [cliente, setCliente] = useState(null);
  const [usuariosRS, setUsuariosRS] = useState([]);
  const [asistentesExt, setAsistentesExt] = useState([]);

  const getData = useCallback(async () => {
    if (!empresa?.userId) return;

    try {
      const response = await GET_CLIENT_CONTACT();
      const client = response?.find(a => a?.userId === empresa.userId);
      setCliente(client);
    } catch (err) {
      console.error("Error al obtener cliente:", err);
    }

    try {
      const rsUsers = await GET_USERS_RS();
      setUsuariosRS(rsUsers);
    } catch (err) {
      console.error("Error al obtener usuarios RS:", err);
    }

    try {
      const extUsers = await GET_ASSISTANTS_BY_CLIENT(empresa.userId);
      setAsistentesExt(extUsers);
    } catch (err) {
      console.error("Error al obtener asistentes externos:", err);
    }
  }, [empresa]);

  useEffect(() => {
    getData();
  }, [getData]);

  return { cliente, usuariosRS, asistentesExt, refreshData: getData };
};

export default useFetchMeetingData;